import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import styles from '../../../src/assets/styles/HomePage.module.scss';
import Header from '../Header';
import Footer from '../Footer'
import NovinkyComponent from '../NovinkyComponent';
import OteviraciDoba from '../OteviraciDoba';
import KdeNasNajdete from '../KdeNasNajdete';
import { HashLink as Link } from 'react-router-hash-link';

const HomePage = () => {

    return (
        <div>
            <Container fluid className={`g-0`}>
                <Header headerAbsolute={true}/>
                <div className={`${styles.heroImage} ${styles.heroImageHomePage}`}>
                    <div className={styles.heroText}>
                        <h1>Dětská herna Mauglí</h1>
                        <p className='lead'>Dětská herna s kavárnou, kde se vaše děti vyřádí, zatímco Vy si v klidu vypijete kafíčko.</p>
                        <Link smooth to="#kdeNasNajdete">
                            <Button className='btn-outline-hermiona-light' size="lg">Pojď si hrát</Button>
                        </Link>
                    </div>
                </div>
            
            </Container>
            
            <Container fluid className=' p-4'>
                <Row className='justify-content-center'>
                    <Col xs="12" lg="8" className='d-flex flex-column justify-content-center text-center'>
                        <h2>O nás</h2>
                        <p className='lead'>Herna Mauglí je ideálním místem pro rodinné odpoledne, kde si děti užijí zábavu a rodiče si mohou v klidu vypít skvělou kávu. Naše prostory v Neratovicích nabízejí bezpečné a stimulující prostředí, kde se vaše děti mohou vyřádit a zároveň rozvíjet své sociální dovednosti.</p>
                        <p className='lead'>Plánujete oslavu narozenin? Přenechte organizaci nám a užijte si nezapomenutelnou party plnou her, smíchu a dobrého jídla. Naše kavárna zajišťuje občerstvení pro všechny malé hosty i jejich rodiče. Stačí zavolat a všechno ostatní je na nás.</p>
                        <p className='lead fw-bolder'>Navštivte nás a přesvědčte se, že Herna Mauglí je místem, kde každý najde svůj koutek štěstí.</p>
                    </Col>
                </Row>
            </Container>

            <Container fluid className=''>
                <Row>
                    <Col xs="12" lg="6" className='d-flex bg-hermiona-light p-4' id="kdeNasNajdete">
                        <KdeNasNajdete/>
                    </Col>

                    <Col xs="12" lg="6" className='bg-frodo-light p-4'>
                        <OteviraciDoba type="forMain"/>
                    </Col>
                </Row>
            </Container>

            <NovinkyComponent limit={3} />

            <Footer/>
        </div >
    );
};

export default HomePage;